import { UpdatedTranslations } from "entities/translations/types";
import some from "lodash/some";
import sumBy from "lodash/sumBy";

export const defineNoEnglishTranslate = (
  updatedTranslations: UpdatedTranslations | null,
) =>
  updatedTranslations
    ? some(
        Object.values(updatedTranslations),
        (translate) => !String(translate.en).trim(),
      )
    : false;

export const getTotalUnpublishedChanges = (
  updatedTranslations: UpdatedTranslations | null,
) =>
  updatedTranslations
    ? sumBy(
        Object.values(updatedTranslations),
        (next) => Object.keys(next).length,
      )
    : 0;
